import React from "react";
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import Homepage from "../pages/Homepage";
import MainLayout from "../components/MainLayout";
import InternalUsers from "../pages/InternalUsers";
import AddInternalUser from "../pages/AddInternalUser";
import Login from "../pages/Login";
import Branch from "../pages/Branch";
import UpdateInternalUser from "../pages/UpdateInternalUser";
import Staff from "../pages/Staff";
import Borrower from "../pages/Borrower";
import Market from "../pages/Market";
import AvantiSpecialAudit from "../pages/AvantiSpecialAudit";
import LucknowSpecialAudit from "../pages/LucknowSpecialAudit";
import RiskReviewAudit from "../pages/RiskReviewAudit";

const Allroutes = () => {
    return (
        <Router basename={'/'} >
            <Routes>
                <Route exact path="/" element={<Login />} />
                <Route exact path="/login" element={<Login />} />
                <Route path="/dashboard" element={<MainLayout title={'Dashboard'}><Homepage /></MainLayout>} />
                <Route path="/users" element={<MainLayout title={'Internal Users'}><InternalUsers /></MainLayout>} />
                <Route path="/add-internal-user" element={<MainLayout title={'Add User'}><AddInternalUser /></MainLayout>} />
                <Route path="/branch" element={<MainLayout title={'Branch'}><Branch /></MainLayout>} />
                <Route path="/staff" element={<MainLayout title={'Staff'}><Staff /></MainLayout>} />
                <Route path="/borrower" element={<MainLayout title={'Borrower'}><Borrower /></MainLayout>} />
                <Route path="/update-user" element={<MainLayout title={'Update User'}><UpdateInternalUser /></MainLayout>} />
                <Route path="/market" element={<MainLayout title={'Market'}><Market /></MainLayout>} />
                <Route path="/avanti-special-audit" element={<MainLayout title={'Avanti Special Audit'}><AvantiSpecialAudit /></MainLayout>} />
                <Route path="/lucknow-special-audit" element={<MainLayout title={'Lucknow Special Audit'}><LucknowSpecialAudit /></MainLayout>} />
                <Route path="/employees-list" element={<MainLayout title={'Employees List'}><LucknowSpecialAudit /></MainLayout>} />
                <Route path="/risk-review-audit" element={<MainLayout title={'Risk Review Audit'}><RiskReviewAudit /></MainLayout>} />
            </Routes>
        </Router>
    )
}

export default Allroutes;
